<template>
    <v-col id="base" md="12" class="mt-0 pt-0">
        <v-row justify="center" class="pt-8 pb-4">
            <h1 @click="$router.push({ name: 'order_in_process'});" >Confirma tu pedido</h1>
        </v-row>
        <v-row justify="center" style="position: relative; width: 300px; margin: 0 auto;" >
            <v-col  class="pt-0 mt-0 elevation-4 pb-0 mb-0" >
                <v-row style="background-color: #EEEEEE; color: #BFBBBA; font-size: 14px" class="pt-4 pb-4 pl-4">
                    Resumen
                </v-row>
                <v-row style="color: gray;" class="pb-4">
                    <v-col class="pl-8">
                        <v-row style="color: black" class="pb-2">
                            <h2>{{address.name}}</h2>
                        </v-row>
                        <v-row style="font-size: 15px; height: 17px">
                            {{address.street}} #{{address.number}}
                        </v-row>
                        <v-row style="font-size: 15px; height: 17px">
                            {{address.suburb}} {{address.pc}}
                        </v-row>
                        <v-row style="font-size: 15px; height: 17px">
                            {{address.state}}, {{address.city}}
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col style="width: 100%; height: 164px; font-size: 15px; border-bottom: .2px solid; border-color: #F3F3F3;" class="hidscroll pt-0 mt-0">
                        <v-row v-for="(product, index) in products" :key="index" class="pt-0" style=" border-top: .2px solid; border-color: #F3F3F3;" >
                            <v-col md="8" class="pt-0 mt-0 pb-0 mb-0">
                                <v-row justify="start" class="pl-2 pt-4 pb-4" style="font-size: 15px;">
                                    {{product.name}}
                                </v-row>
                            </v-col >
                            <v-col md="4" class="pt-0 mt-0 pb-0 mb-0">
                                <v-row justify="end" class="pr-2 pt-4 pb-4" style="font-size: 15px; color: gray;">
                                    ${{product.price}}
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" class="pt-0 pb-0"  style="width: 300px;">
                    <v-col md="8" class="pt-0 mt-0 pb-0 mb-0">
                        <v-row justify="start" class="pl-2 pt-4 pb-4" style="font-size: 15px;">
                            SUB TOTAL
                        </v-row>
                    </v-col >
                    <v-col md="4" class="pt-0 mt-0 pb-0 mb-0">
                        <v-row justify="end" class="pr-2 pt-4 pb-4" style="font-size: 15px; color: gray;">
                            {{total()}}
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
  export default {
    data () {
      return {
        address: {
                name:   "Quebracho Lerma",
                street: "Rio Lerma",
                number: "175-A",
                suburb: "Col. Cuahutemoc",
                pc:     "06500",
                state:  "Ciudad de México",
                city:   "CDMX"
            
        },
        products: [
            {
                name: "Empanada Humita",
                price: 40.00,
            },
            {
                name: "Rib Eye 300 gr",
                price: 250.00,
            },
            {
                name: "Pie queso c/ zarzamora",
                price: 80.00,
            },
            {
                name: "Pie queso c/ zarzamora",
                price: 80.00,
            },
            {
                name: "Pie queso c/ zarzamora",
                price: 80.00,
            },
        ],
      }
    },
    methods: {
        total() {
            var suma = 0;
            for(let product in this.products)
            {
                suma += this.products[product].price;
            }
            const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0
            })
            return formatter.format(suma);
        },
    },
  }
</script>

<style scoped>

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden
    }
    
</style>